<template>
  <footer class="site-footer">
    <hr>
    {{ copyright }}
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      copyright: state => state.theme.copyright
    })
  }
}
</script>
